import React from "react"
import FieldProto_FormElement from "../../../../proto/render/form-element";
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const";
import SelectParentNew from "../../../../../gd-ui/select-parent-new/select-parent-new";
import ProjectSessionCollection from "../../../../../model2/project/collection";
import FieldProject from "../../../../generic/entity/project/project";
import ProjectSession from "../../../../../model2/project/project-session";

export default class FieldExpenseProject_FormElement extends FieldProto_FormElement {

    render() {
        const field: FieldProject = this.props.field as FieldProject

        // Filter projects
        let userProjects : any[] = [];

        gd.session.projectUsers.map((pu:any)=>{                         // Old collection !!!!
            if (pu.project && pu.user && pu.user.id === gd.session.me.id) {
                const project = gd.session.projects.get(pu.project.id);
                const expensesEnabled = _.get(project, 'properties.expenses', false);
                if (expensesEnabled) userProjects.push(project)
            }
        });

        userProjects = _.uniqBy(userProjects, (project: ProjectSession) => project.id)
        const availableProjects = new ProjectSessionCollection(userProjects)

        return <SelectParentNew className           = {this.props.className}
                                projectId           = {this.value}
                                parentsFor          = {field.parentsFor}
                                placeholder         = {field.placeholder}
                                availableProjects   = {availableProjects}
                                renderType          = {SelectParent_RenderType.FORM}
                                onChange            = {this.onChange}/>
    }
}
